<mat-dialog-content class="mat-typography" style="width: 469px; ">
  <div class="section_login">
    <button style="outline: none;" class="close-button forgetPass" (click)="CloseModal()" [mat-dialog-close]="true"
      id="closeBtn">
      <img src="../../../assets/icons/x-button.svg">
    </button>


    <div class="row">

      <div class="col-sm-12 successTitle" id="sharedCode">
        <h2>{{data.userType.titleOne}}</h2>
        <p>{{data.userType.text}}</p>
        <mat-form-field appearance="fill">
          <input matInput disabled="true" [value]="data.userType.sharedCode"
            style="padding-bottom: 10px;">
            <!-- border-bottom: 1px solid #ccc -->
          <!-- <img src="../../../../assets/SVG/copy.svg" alt="" [matTooltip]="shareCodeText" (click)="copyCode(data.userType.sharedCode)"  style="cursor: pointer;font-size: 20px; transform: translate(0px, -5px);"> -->
          <mat-icon matSuffix [matTooltip]="shareCodeText" (click)="copyCode(data.userType.sharedCode)"
            style="cursor: pointer;font-size: 20px; transform: translate(-1em, -5px);"><img
              src="../../../../assets/SVG/copy.svg" class="teamscopyicnn" alt="" style="padding-bottom: 15px;"></mat-icon>
        </mat-form-field>
      </div>

      <div class="col-md-12">
        <button mat-raised-button color="warn" [mat-dialog-close]="true" (click)="AddMoreTeams()" class="authSignIn">Add
          More Teams</button>
      </div>
    </div>
  </div>
</mat-dialog-content>
